module.exports = __webpack_public_path__ + "static/media/pip.240ea06f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/pip.mp4
// module id = 339
// module chunks = 0